export default "__VITE_ASSET__Pqe2jnsb__"